import React, { useState } from 'react';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import CustomDatePicker from 'view/component/CustomDatePicker';
import HistoryTanggalKunjungan from './HistoryTanggalKunjungan';

const FormTanggalKunjungan = ({
  isModalShow,
  setIsModalShow,
  data,
  verifiedComplete,
  setTanggalKunjungan,
  visitDateHistory,
}) => {
  const [ tanggal, setTanggal ] = useState(
    visitDateHistory[ visitDateHistory.length - 1 ]
      ? new Date(visitDateHistory[ visitDateHistory.length - 1 ].visit_date)
      : new Date()
  );
  const [ name, setName ] = useState(
    visitDateHistory[ visitDateHistory.length - 1 ] &&
      visitDateHistory[ visitDateHistory.length - 1 ].nama
  );
  const [ reason, setReason ] = useState(
    visitDateHistory[ visitDateHistory.length - 1 ] &&
      visitDateHistory[ visitDateHistory.length - 1 ].alasan
  );
  const [ isHistoryShow, setIsHistoryShow ] = useState(false);

  console.log(visitDateHistory);

  return (
    <>
      <Modal
        show={ isModalShow }
        onHide={ () => setIsModalShow(false) }
        size='sm'
        centered>
        <Modal.Body>
          {Object.values(data).length !== 0 &&
          Object.values(data).length ===
            Object.values(verifiedComplete).length ? (
              <div className='d-flex flex-column justify-content-center'>
                <h2 className='align-self-center'>
                  {/* Tanggal : {moment(tanggal).format('DD-MM-YYYY')} */}
                </h2>
                <div className='form-group'>
                  <label className='form-control-label'>Pengubah</label>
                  <input
                    value={ name }
                    className='form-control'
                    placeholder='Pengubah'
                    onChange={ (e) => setName(e.target.value) }
                  />
                </div>
                <div className='form-group'>
                  <label className='form-control-label'>Alasan</label>
                  <input
                    value={ reason }
                    className='form-control'
                    placeholder='Alasan'
                    onChange={ (e) => setReason(e.target.value) }
                  />
                </div>
                <div className='form-group'>
                  <label className='form-control-label'>Tanggal kunjungan</label>
                  <CustomDatePicker
                    value={ tanggal }
                    onChange={ (date) => setTanggal(date) }
                  />
                  <span onClick={ () => setIsHistoryShow(true) } style={ { cursor:'pointer' } } className='text-primary'>History</span>
                </div>
                {/* <div className='d-inline align-self-center mt-2'>
                          <DatePicker
                            selected={ tanggal }
                            onChange={ (date) => setTanggal(date) }
                          />
                        </div> */}
                <div className='d-flex justify-content-center mt-2'>
                  {/* <button
                          onClick={ () => setIsModalShow(false) }
                          className='mr-3'>
                          Cancel
                        </button> */}
                  <button
                    className='btn btn-success'
                    onClick={ () =>
                      setTanggalKunjungan(
                        {
                          date: moment(tanggal).format('YYYY-MM-DD'),
                          name,
                          reason,
                        },
                        () => setIsModalShow(false)
                      )
                    }>
                  Confirm
                  </button>
                  {/* <button
                    className='btn btn-success'
                    onClick={ () => setIsHistoryShow(true) }>
                  History
                  </button> */}
                </div>
              </div>
            ) : (
              <h2 className='text-center'>
              Pastikan semua persyaratan terverifikasi
              </h2>
            )}
        </Modal.Body>
      </Modal>
      <HistoryTanggalKunjungan
        isModalShow={ isHistoryShow }
        setIsModalShow={ setIsHistoryShow }
        visitDateHistory={ visitDateHistory || [] }
      />
    </>
  );
};

export default FormTanggalKunjungan;
